import styled, { keyframes } from "styled-components";

const float = keyframes`
  0%, 100% { transform: translateY(0px); }
  50%       { transform: translateY(-8px); }
`;

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 60px - 56px); /* 헤더 + 패딩 제외 */
  padding: 48px 24px;
  text-align: center;
`;

export const IconWrap = styled.div`
  font-size: 56px;
  margin-bottom: 28px;
  animation: ${float} 3s ease-in-out infinite;
  user-select: none;
`;

export const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background-color: #fff8e6;
  border: 1px solid #fde68a;
  color: #b45309;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 4px 12px;
  border-radius: 999px;
  margin-bottom: 20px;
`;

export const BadgeDot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #f59e0b;
  display: inline-block;
`;

export const Title = styled.h2`
  font-size: 26px;
  font-weight: 900;
  color: #111;
  letter-spacing: -0.02em;
  margin-bottom: 10px;
`;

export const Desc = styled.p`
  font-size: 14px;
  color: #999;
  line-height: 1.8;
  margin-bottom: 40px;
  max-width: 320px;
  word-break: keep-all;
`;

export const FeatureBox = styled.div`
  width: 100%;
  max-width: 420px;
  background-color: #fff;
  border: 1px solid #eaeaea;
  border-radius: 16px;
  padding: 24px 28px;
  text-align: left;
`;

export const FeatureBoxTitle = styled.p`
  font-size: 12px;
  font-weight: 700;
  color: #bbb;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 16px;
`;

export const FeatureList = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FeatureItem = styled.li`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: #444;
  font-weight: 500;
`;

export const FeatureDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #e0e0e0;
  flex-shrink: 0;
`;
